export function getTheme() {
  const brandName = window.location.hostname.split('.')[0];
  if (brandName === 'cend') {
    return {
      logo: '//cdn.pricepointmoves.com/public/CendPPLogo.png',
      primary: '#2d5ca8',
      accent: '#80bc00',
      accent2: '#243746',
    };
  }
  if (brandName === 'atlantic') {
    return {
      logo: '//cdn.pricepointmoves.com/public/AtlanticIntlLogo.png',
      primary: '#007ebd',
      accent: '#cf1238',
      accent2: '#005696',
    };
  }

  return {
    logo: '//cdn.pricepointmoves.com/public/PricePoint-logo.png',
    primary: '#173059',
    accent: '#009BDE',
    accent2: '#ee7701',
  };
}

const mainBackground = {
  height: '100vh',
  background: `linear-gradient(to bottom, ${getTheme().primary} 50%, rgb(242, 242, 248) 50%)`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const logoBackground = {
  backgroundColor: getTheme().primary,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const submitButton = {
  width: '100%',
  backgroundColor: getTheme().primary,
  color: 'white',
  borderRadius: '0px',
};

const signupButton = {
  width: '100%',
  backgroundColor: getTheme().accent2,
  color: 'white',
  borderRadius: '0px',
};

const link = {
  textTransform: 'uppercase',
  textDecoration: 'none',
  color: getTheme().accent,
  fontSize: '0.9em',
  fontWeight: 'bold',
};

export default {
  mainBackground,
  logoBackground,
  submitButton,
  signupButton,
  link,
};
